import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaPaintBrush,
  FaHeart,
  FaStar,
  FaTruck,
  FaGlobe,
  FaCheck,
  FaLightbulb,
  FaPalette,
  FaClipboardCheck,
  FaInstagram,
  FaUsers,
  FaSmile,
  FaShieldAlt,
  FaHandsHelping
} from 'react-icons/fa';

/* ============================================================
   LOGO IMPORT
   ============================================================ */

import logo from '../logos/nooralnoor/Nuawa_Ali_Noorlogo.png';

/* ============================================================
   SIX LOCAL IMAGE IMPORTS
   Change only these filenames if your actual filenames differ.
   ============================================================ */

import artwork1 from '../logos/nooralnoor/noorulain1.png';
import artwork2 from '../logos/nooralnoor/noorulain2.png';
import artwork3 from '../logos/nooralnoor/noorulain3.png';
import roomImage from '../logos/nooralnoor/noorulain4.png';
import customerImage1 from '../logos/nooralnoor/noorulain5.png';
import customerImage2 from '../logos/nooralnoor/noorulain6.png';


export default function NoorUnAlaaNoor() {

  const navigate = useNavigate();

  /* ============================================================
     SCROLL REVEAL ANIMATION
     ============================================================ */

  useEffect(() => {
    const elements = document.querySelectorAll('.reveal');

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.12
      }
    );

    elements.forEach(element => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ======================================================
          GLOBAL STYLE
          ====================================================== */}

      <style>{`

        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
          background: #f7f1e8;
        }

        img {
          max-width: 100%;
        }

        button {
          font-family: inherit;
        }

        /* ====================================================
           PAGE
           ==================================================== */

        .noor-page {
          width: 100%;
          min-height: 100vh;
          background:
            radial-gradient(
              circle at top left,
              rgba(255,255,255,0.9),
              transparent 35%
            ),
            #f7f1e8;
          color: #242424;
          font-family:
            "Segoe UI",
            Arial,
            sans-serif;
          overflow-x: hidden;
        }

        /* ====================================================
           TOP NAV
           ==================================================== */

        .noor-top-nav {
          width: 100%;
          padding: 12px 25px;
          background: #ffffff;
          border-bottom: 1px solid #ead8bd;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 3px 15px rgba(0,0,0,0.06);
        }

        .noor-nav-inner {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .noor-back-btn {
          border: none;
          outline: none;
          background: #182d55;
          color: #ffffff;
          padding: 10px 18px;
          border-radius: 25px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 700;
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease,
            background 0.3s ease;
        }

        .noor-back-btn:hover {
          background: #9b174d;
          transform: translateX(-4px);
          box-shadow: 0 7px 20px rgba(155,23,77,0.25);
        }

        .noor-nav-logo {
          height: 45px;
          width: auto;
          object-fit: contain;
        }

        /* ====================================================
           MAIN POSTER
           FULL WIDTH
           ==================================================== */

        .noor-poster {
          width: 100%;
          margin: 0;
          padding: 28px clamp(18px, 4vw, 65px) 0;
          background:
            linear-gradient(
              180deg,
              #fffdfa 0%,
              #fffaf3 45%,
              #fdf7ee 100%
            );
          overflow: hidden;
        }

        .poster-inner {
          width: 100%;
          max-width: 1700px;
          margin: 0 auto;
        }

        /* ====================================================
           REVEAL ANIMATION
           ==================================================== */

        .reveal {
          opacity: 0;
          transform: translateY(35px);
          transition:
            opacity 0.8s ease,
            transform 0.8s ease;
        }

        .reveal.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .delay-1 {
          transition-delay: 0.1s;
        }

        .delay-2 {
          transition-delay: 0.2s;
        }

        .delay-3 {
          transition-delay: 0.3s;
        }

        .delay-4 {
          transition-delay: 0.4s;
        }

        /* ====================================================
           HERO SECTION
           ==================================================== */

        .noor-hero {
          width: 100%;
          min-height: 570px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          align-items: stretch;
          margin-bottom: 30px;
        }

        .hero-left {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 35px 25px;
        }

        .introducing-line {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 18px;
          color: #333;
          font-size: 15px;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .introducing-line::before {
          content: "✧";
          color: #c68a2b;
          font-size: 25px;
        }

        .introducing-line::after {
          content: "";
          width: 130px;
          height: 1px;
          background: #c68a2b;
        }

        .hero-title {
          margin: 0;
          color: #142b52;
          font-family:
            Georgia,
            "Times New Roman",
            serif;
          font-size: clamp(48px, 6vw, 92px);
          line-height: 0.92;
          letter-spacing: -2px;
          font-weight: 700;
        }

        .hero-title span {
          display: block;
          color: #b92a65;
          margin-top: 5px;
        }

        .hero-tagline {
          margin-top: 25px;
          color: #3c3c3c;
          font-size: clamp(14px, 1.4vw, 20px);
          letter-spacing: 1px;
          font-weight: 500;
        }

        .hero-description {
          max-width: 620px;
          margin-top: 25px;
          color: #3d3d3d;
          font-size: 16px;
          line-height: 1.75;
        }

        /* ====================================================
           QUOTE
           ==================================================== */

        .quran-box {
          position: relative;
          margin-top: 25px;
          max-width: 650px;
          padding: 25px 35px;
          border: 1px solid #dfbd7b;
          border-radius: 20px;
          background: rgba(255,255,255,0.65);
          transition:
            transform 0.4s ease,
            box-shadow 0.4s ease;
        }

        .quran-box:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 35px rgba(105,71,27,0.1);
        }

        .quran-quote {
          margin: 0;
          color: #383838;
          font-size: 16px;
          line-height: 1.6;
          font-style: italic;
        }

        .quran-reference {
          display: block;
          margin-top: 10px;
          color: #b51d5d;
          font-size: 14px;
          font-weight: 700;
        }

        .quote-left,
        .quote-right {
          position: absolute;
          color: #b51d5d;
          font-size: 45px;
          line-height: 1;
          opacity: 0.65;
        }

        .quote-left {
          left: 12px;
          top: 8px;
        }

        .quote-right {
          right: 15px;
          bottom: 0;
        }

        /* ====================================================
           HERO RIGHT
           ==================================================== */

        .hero-right {
          position: relative;
          min-height: 570px;
          overflow: hidden;
          border-radius: 35px;
          background:
            linear-gradient(
              135deg,
              #fff1bd,
              #f7bd42 25%,
              #e93054 55%,
              #7d1c8b 75%,
              #172e66
            );
          display: flex;
          align-items: center;
          justify-content: center;
          isolation: isolate;
        }

        .hero-right::before {
          content: "";
          position: absolute;
          width: 650px;
          height: 650px;
          border-radius: 50%;
          background:
            radial-gradient(
              circle,
              rgba(255,255,255,0.45),
              transparent 65%
            );
          animation: heroGlow 7s ease-in-out infinite alternate;
        }

        @keyframes heroGlow {
          from {
            transform: translate(-80px,-40px) scale(0.9);
          }

          to {
            transform: translate(80px,50px) scale(1.1);
          }
        }

        .follow-card {
          position: absolute;
          top: 25px;
          right: 25px;
          z-index: 5;
          background: #142b52;
          color: #ffffff;
          padding: 15px 22px;
          border-radius: 18px;
          min-width: 240px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.18);
          animation: floating 4s ease-in-out infinite;
        }

        @keyframes floating {
          0%,
          100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-7px);
          }
        }

        .follow-title {
          display: block;
          font-size: 12px;
          letter-spacing: 1px;
          margin-bottom: 7px;
          font-weight: 700;
        }

        .follow-instagram {
          display: flex;
          align-items: center;
          gap: 7px;
          font-size: 13px;
          font-weight: 700;
        }

        .arabic-art {
          position: relative;
          z-index: 3;
          text-align: center;
          color: #ffffff;
          padding: 50px 30px;
        }

        .arabic-text {
          font-family:
            "Amiri",
            "Noto Naskh Arabic",
            "Traditional Arabic",
            serif;
          font-size: clamp(55px, 7vw, 105px);
          line-height: 1.15;
          font-weight: 700;
          text-shadow: 0 5px 20px rgba(0,0,0,0.18);
          animation: arabicFloat 5s ease-in-out infinite;
        }

        @keyframes arabicFloat {
          0%,
          100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-10px);
          }
        }

        .arabic-subtitle {
          margin-top: 25px;
          font-family: Georgia, serif;
          font-size: 20px;
          line-height: 1.5;
          font-style: italic;
          color: #ffffff;
        }

        /* ====================================================
           FEATURES
           ==================================================== */

        .features-banner {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          background: linear-gradient(
            90deg,
            #ad1555,
            #c21e61,
            #ad1555
          );
          border-radius: 18px;
          padding: 10px;
          margin-bottom: 40px;
          box-shadow: 0 15px 35px rgba(140,20,72,0.15);
        }

        .feature-item {
          min-height: 105px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 12px;
          color: #ffffff;
          border-right: 1px solid rgba(255,255,255,0.35);
          transition:
            transform 0.35s ease,
            background 0.35s ease;
        }

        .feature-item:last-child {
          border-right: none;
        }

        .feature-item:hover {
          transform: translateY(-7px);
          background: rgba(255,255,255,0.08);
        }

        .feature-icon {
          color: #f5ca72;
          font-size: 28px;
          margin-bottom: 12px;
        }

        .feature-text {
          font-size: 12px;
          line-height: 1.4;
          font-weight: 700;
          letter-spacing: 0.4px;
        }

        /* ====================================================
           SECTION TITLE
           ==================================================== */

        .section-title {
          text-align: center;
          color: #81224f;
          font-size: clamp(22px, 3vw, 34px);
          font-family: Georgia, serif;
          letter-spacing: 1px;
          margin: 25px 0 25px;
          position: relative;
        }

        .section-title::before,
        .section-title::after {
          content: "✧";
          color: #d19b39;
          margin: 0 18px;
          font-size: 20px;
        }

        /* ====================================================
           ART + STORY
           ==================================================== */

        .art-story {
          width: 100%;
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 35px;
          margin-bottom: 45px;
        }

        .art-gallery {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 15px;
        }

        .art-card {
          height: 390px;
          overflow: hidden;
          border-radius: 15px;
          border: 1px solid #d9c5a0;
          background: #ffffff;
          box-shadow: 0 8px 25px rgba(0,0,0,0.08);
          cursor: pointer;
        }

        .art-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition:
            transform 0.7s ease,
            filter 0.7s ease;
        }

        .art-card:hover img {
          transform: scale(1.08);
          filter: saturate(1.1);
        }

        .story-card {
          border-left: 2px solid #d5a64e;
          padding: 25px 25px 25px 35px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .story-title {
          color: #8d2052;
          font-family: Georgia, serif;
          font-size: 27px;
          margin-bottom: 20px;
          font-weight: 700;
        }

        .story-title::after {
          content: "";
          display: block;
          width: 100px;
          height: 2px;
          background: #d2a04d;
          margin-top: 8px;
        }

        .story-text {
          color: #444;
          font-size: 15px;
          line-height: 1.75;
          margin: 0 0 17px;
        }

        .women-badge {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #f8e9f0;
          border-radius: 40px;
          padding: 13px 18px;
          color: #9e1851;
          font-size: 13px;
          font-weight: 800;
          margin-top: 12px;
        }

        .women-badge svg {
          font-size: 24px;
        }

        /* ====================================================
           INFORMATION SECTION
           ==================================================== */

        .information-grid {
          width: 100%;
          display: grid;
          grid-template-columns: 0.9fr 1.3fr 0.9fr;
          gap: 25px;
          margin-bottom: 45px;
        }

        .info-column {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }

        .info-card {
          background: rgba(255,255,255,0.75);
          border: 1px solid #dfceb2;
          border-radius: 18px;
          padding: 25px;
          transition:
            transform 0.35s ease,
            box-shadow 0.35s ease;
        }

        .info-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 30px rgba(80,40,20,0.09);
        }

        .info-title {
          color: #8a2150;
          font-family: Georgia, serif;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #dfc58f;
        }

        .check-list {
          padding: 0;
          margin: 0;
          list-style: none;
        }

        .check-list li {
          display: flex;
          align-items: flex-start;
          gap: 9px;
          color: #4a4a4a;
          font-size: 13px;
          line-height: 1.55;
          margin-bottom: 12px;
        }

        .check-list svg {
          flex-shrink: 0;
          color: #a91854;
          margin-top: 3px;
        }

        /* ====================================================
           PROCESS
           ==================================================== */

        .process-card {
          background: #ffffff;
          border: 1px solid #dfceb2;
          border-radius: 18px;
          padding: 25px;
        }

        .process-row {
          display: grid;
          grid-template-columns: 1fr auto 1fr auto 1fr auto 1fr;
          align-items: center;
          gap: 8px;
        }

        .process-step {
          text-align: center;
          transition: transform 0.35s ease;
        }

        .process-step:hover {
          transform: translateY(-7px);
        }

        .process-circle {
          width: 65px;
          height: 65px;
          border-radius: 50%;
          margin: 0 auto 10px;
          border: 2px solid #c39b51;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #8d2052;
          background: #fffaf1;
          font-size: 24px;
          transition:
            transform 0.4s ease,
            background 0.4s ease;
        }

        .process-step:hover .process-circle {
          transform: rotate(8deg) scale(1.08);
          background: #f8e6ef;
        }

        .process-label {
          display: block;
          color: #444;
          font-size: 11px;
          font-weight: 800;
          line-height: 1.4;
        }

        .process-arrow {
          color: #c4933d;
          font-size: 25px;
          font-weight: 700;
        }

        .process-description {
          margin: 25px 0 0;
          text-align: center;
          color: #555;
          font-size: 14px;
          font-style: italic;
          line-height: 1.6;
        }

        /* ====================================================
           ROOM IMAGE
           ==================================================== */

        .room-card {
          width: 100%;
          height: 270px;
          overflow: hidden;
          border-radius: 18px;
          border: 1px solid #dfceb2;
          background: #ffffff;
        }

        .room-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.8s ease;
        }

        .room-card:hover img {
          transform: scale(1.06);
        }

        /* ====================================================
           CUSTOMER + INSTAGRAM
           ==================================================== */

        .customer-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }

        .customer-card {
          background: #ffffff;
          border: 1px solid #dfceb2;
          border-radius: 18px;
          padding: 20px;
        }

        .customer-images {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .customer-image {
          width: 100%;
          height: 145px;
          object-fit: cover;
          border-radius: 12px;
          transition:
            transform 0.45s ease,
            box-shadow 0.45s ease;
        }

        .customer-image:hover {
          transform: scale(1.04);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }

        /* ====================================================
           INSTAGRAM
           ==================================================== */

        .instagram-card {
          border-radius: 18px;
          background:
            linear-gradient(
              135deg,
              #172e66,
              #6b215d,
              #a71b56
            );
          color: #ffffff;
          padding: 25px;
          position: relative;
          overflow: hidden;
        }

        .instagram-card::after {
          content: "";
          position: absolute;
          width: 160px;
          height: 160px;
          border-radius: 50%;
          border: 25px solid rgba(255,255,255,0.08);
          right: -50px;
          bottom: -50px;
        }

        .instagram-profile {
          display: flex;
          align-items: center;
          gap: 12px;
          position: relative;
          z-index: 2;
        }

        .instagram-avatar {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: #ffffff;
          color: #a51d56;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: 800;
          border: 3px solid rgba(255,255,255,0.6);
        }

        .instagram-name {
          font-size: 16px;
          font-weight: 800;
        }

        .instagram-stats {
          font-size: 11px;
          opacity: 0.8;
          margin-top: 4px;
        }

        .instagram-content {
          margin-top: 35px;
          position: relative;
          z-index: 2;
        }

        .instagram-content h3 {
          margin: 0 0 15px;
          font-size: 16px;
          line-height: 1.5;
        }

        .instagram-handle {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;
          color: #ffd6e8;
          font-weight: 800;
        }

        .instagram-small {
          display: block;
          margin-top: 12px;
          font-size: 12px;
          opacity: 0.85;
        }

        /* ====================================================
           BOTTOM QUOTE
           ==================================================== */

        .bottom-quote {
          width: 100%;
          min-height: 170px;
          border-radius: 25px 25px 0 0;
          padding: 35px 30px;
          background:
            linear-gradient(
              90deg,
              #a51c57,
              #d22c5f,
              #b21b68
            );
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 25px;
          position: relative;
          overflow: hidden;
        }

        .bottom-quote::before {
          content: "";
          position: absolute;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          border: 70px solid rgba(255,255,255,0.05);
          left: -160px;
          top: -170px;
        }

        .bottom-quote-symbol {
          font-family: Georgia, serif;
          font-size: 75px;
          line-height: 1;
          color: #ffd1e4;
        }

        .bottom-quote-content {
          text-align: center;
          position: relative;
          z-index: 2;
        }

        .bottom-quote-text {
          display: block;
          font-family: Georgia, serif;
          font-size: clamp(21px, 3vw, 34px);
          font-style: italic;
          font-weight: 600;
        }

        .bottom-quote-sub {
          display: block;
          margin-top: 12px;
          font-size: 14px;
          letter-spacing: 0.6px;
        }

        /* ====================================================
           FOOTER
           ==================================================== */

        .noor-footer {
          width: 100%;
          background: #fffdf8;
          border-top: 3px solid #c49239;
          display: grid;
          grid-template-columns: 110px 1fr 2fr;
          gap: 25px;
          align-items: center;
          padding: 20px 0;
        }

        .footer-page-number {
          font-family: Georgia, serif;
          font-size: 65px;
          line-height: 1;
          font-weight: 700;
          color: #6f1b61;
          text-align: center;
        }

        .footer-company {
          display: flex;
          flex-direction: column;
        }

        .footer-company-name {
          color: #192c4f;
          font-size: 20px;
          font-weight: 900;
          letter-spacing: 0.5px;
        }

        .footer-company-tagline {
          margin-top: 5px;
          color: #c38c36;
          font-family: Georgia, serif;
          font-size: 14px;
        }

        .footer-pillars {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
        }

        .footer-pillar {
          min-height: 60px;
          padding: 0 10px;
          border-left: 1px solid #dbcaa7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          gap: 7px;
          color: #303d52;
          font-size: 9px;
          font-weight: 800;
        }

        .footer-pillar svg {
          color: #1b315a;
          font-size: 22px;
        }

        /* ====================================================
           TABLET
           ==================================================== */

        @media (max-width: 1100px) {

          .noor-poster {
            padding-left: 25px;
            padding-right: 25px;
          }

          .hero-title {
            font-size: clamp(48px, 7vw, 72px);
          }

          .art-card {
            height: 300px;
          }

          .information-grid {
            grid-template-columns: 1fr 1.4fr;
          }

          .information-grid > .info-column:last-child {
            grid-column: 1 / -1;
          }

          .footer-company-name {
            font-size: 16px;
          }
        }

        /* ====================================================
           TABLET / MOBILE
           ==================================================== */

        @media (max-width: 800px) {

          .noor-top-nav {
            padding: 10px 15px;
          }

          .noor-nav-logo {
            height: 38px;
          }

          .noor-back-btn {
            padding: 9px 13px;
            font-size: 11px;
          }

          .noor-poster {
            padding: 18px 15px 0;
          }

          .noor-hero {
            grid-template-columns: 1fr;
            gap: 20px;
          }

          .hero-left {
            padding: 20px 5px;
          }

          .hero-right {
            min-height: 430px;
          }

          .features-banner {
            grid-template-columns: repeat(2, 1fr);
            gap: 0;
          }

          .feature-item {
            border-right: 1px solid rgba(255,255,255,0.3);
            border-bottom: 1px solid rgba(255,255,255,0.3);
          }

          .feature-item:nth-child(2n) {
            border-right: none;
          }

          .feature-item:last-child {
            grid-column: 1 / -1;
            border-right: none;
          }

          .art-story {
            grid-template-columns: 1fr;
          }

          .art-gallery {
            grid-template-columns: repeat(3, 1fr);
          }

          .art-card {
            height: 260px;
          }

          .story-card {
            border-left: none;
            border-top: 2px solid #d5a64e;
            padding: 25px 10px;
          }

          .information-grid {
            grid-template-columns: 1fr;
          }

          .information-grid > .info-column:last-child {
            grid-column: auto;
          }

          .process-row {
            grid-template-columns: 1fr 1fr;
            gap: 25px 10px;
          }

          .process-arrow {
            display: none;
          }

          .customer-row {
            grid-template-columns: 1fr;
          }

          .noor-footer {
            grid-template-columns: 80px 1fr;
          }

          .footer-pillars {
            grid-column: 1 / -1;
          }
        }

        /* ====================================================
           MOBILE
           ==================================================== */

        @media (max-width: 550px) {

          .noor-nav-inner {
            gap: 10px;
          }

          .noor-nav-logo {
            max-width: 120px;
            height: 34px;
          }

          .noor-back-btn {
            padding: 8px 11px;
            font-size: 10px;
          }

          .hero-left {
            padding-top: 15px;
          }

          .introducing-line {
            font-size: 12px;
            gap: 8px;
          }

          .introducing-line::after {
            width: 70px;
          }

          .hero-title {
            font-size: 46px;
            letter-spacing: -1px;
          }

          .hero-tagline {
            font-size: 12px;
            line-height: 1.5;
          }

          .hero-description {
            font-size: 13px;
            line-height: 1.65;
          }

          .quran-box {
            padding: 20px 25px;
          }

          .quran-quote {
            font-size: 13px;
          }

          .quran-reference {
            font-size: 11px;
          }

          .hero-right {
            min-height: 390px;
            border-radius: 20px;
          }

          .follow-card {
            top: 12px;
            right: 12px;
            min-width: 0;
            width: auto;
            padding: 10px 13px;
          }

          .follow-title {
            font-size: 9px;
          }

          .follow-instagram {
            font-size: 10px;
          }

          .arabic-text {
            font-size: 48px;
          }

          .arabic-subtitle {
            font-size: 14px;
          }

          .features-banner {
            border-radius: 13px;
            margin-bottom: 25px;
          }

          .feature-item {
            min-height: 95px;
          }

          .feature-icon {
            font-size: 21px;
          }

          .feature-text {
            font-size: 9px;
          }

          .section-title {
            font-size: 21px;
          }

          .section-title::before,
          .section-title::after {
            margin: 0 6px;
            font-size: 14px;
          }

          .art-gallery {
            grid-template-columns: 1fr;
          }

          .art-card {
            height: 360px;
          }

          .story-title {
            font-size: 23px;
          }

          .story-text {
            font-size: 13px;
          }

          .info-card,
          .process-card,
          .customer-card {
            padding: 18px;
          }

          .info-title {
            font-size: 18px;
          }

          .check-list li {
            font-size: 12px;
          }

          .process-row {
            grid-template-columns: 1fr 1fr;
          }

          .process-circle {
            width: 55px;
            height: 55px;
            font-size: 20px;
          }

          .process-label {
            font-size: 9px;
          }

          .room-card {
            height: 230px;
          }

          .customer-images {
            grid-template-columns: 1fr 1fr;
          }

          .customer-image {
            height: 130px;
          }

          .bottom-quote {
            min-height: 150px;
            padding: 25px 15px;
            gap: 8px;
          }

          .bottom-quote-symbol {
            font-size: 45px;
          }

          .bottom-quote-text {
            font-size: 19px;
          }

          .bottom-quote-sub {
            font-size: 11px;
            line-height: 1.5;
          }

          .noor-footer {
            grid-template-columns: 1fr;
            gap: 15px;
            padding: 25px 0 0;
          }

          .footer-page-number {
            font-size: 48px;
          }

          .footer-company {
            text-align: center;
          }

          .footer-company-name {
            font-size: 14px;
          }

          .footer-company-tagline {
            font-size: 11px;
          }

          .footer-pillars {
            grid-template-columns: repeat(2, 1fr);
          }

          .footer-pillar {
            border-bottom: 1px solid #dbcaa7;
            padding: 15px 5px;
          }

          .footer-pillar:last-child {
            grid-column: 1 / -1;
          }
        }

        /* ====================================================
           VERY SMALL MOBILE
           ==================================================== */

        @media (max-width: 360px) {

          .noor-poster {
            padding-left: 10px;
            padding-right: 10px;
          }

          .hero-title {
            font-size: 39px;
          }

          .hero-right {
            min-height: 350px;
          }

          .arabic-text {
            font-size: 40px;
          }

          .feature-text {
            font-size: 8px;
          }

          .art-card {
            height: 300px;
          }

          .bottom-quote-text {
            font-size: 16px;
          }
        }

      `}</style>

      {/* ======================================================
          PAGE
          ====================================================== */}

      <div className="noor-page">

        {/* ====================================================
            NAVIGATION
            ==================================================== */}

        <nav className="noor-top-nav">

          <div className="noor-nav-inner">

            <button
              className="noor-back-btn"
              onClick={() => navigate('/')}
            >
              <FaArrowLeft />
              <span>Back to All Sectors</span>
            </button>

            <img
              src={logo}
              alt="Noor Un Alaa Noor"
              className="noor-nav-logo"
            />

          </div>

        </nav>


        {/* ====================================================
            POSTER
            ==================================================== */}

        <main className="noor-poster">

          <div className="poster-inner">

            {/* ==================================================
                HERO
                ================================================== */}

            <section className="noor-hero">

              <div className="hero-left reveal">

                <div className="introducing-line">
                  INTRODUCING
                </div>

                <h1 className="hero-title">
                  NOOR UN
                  <span>ALAA NOOR</span>
                </h1>

                <div className="hero-tagline">
                  CALLIGRAPHY THAT SPEAKS. ART THAT INSPIRES.
                </div>

                <p className="hero-description">
                  Noor Un Alaa Noor is a creative calligraphy art
                  initiative under the Ashraf Group of Industries.
                  We create meaningful, hand-painted calligraphy
                  art pieces that reflect faith, beauty and emotion.
                </p>

                <div className="quran-box">

                  <span className="quote-left">
                    “
                  </span>

                  <p className="quran-quote">
                    And We have certainly made the Qur'an
                    easy to understand and remember.
                  </p>

                  <span className="quran-reference">
                    — Surah Al-Qamar (54:17)
                  </span>

                  <span className="quote-right">
                    ”
                  </span>

                </div>

              </div>


              <div className="hero-right reveal delay-2">

                <div className="follow-card">

                  <span className="follow-title">
                    FOLLOW OUR JOURNEY
                  </span>

                  <div className="follow-instagram">
                    <FaInstagram />
                    @noorunalaa_noor
                  </div>

                </div>

                <div className="arabic-art">

                  <div className="arabic-text">
                    نُورٌ عَلَىٰ نُورٍ
                  </div>

                  <div className="arabic-subtitle">
                    Where Faith Meets Art.
                    <br />
                    Where Words Become Beauty.
                  </div>

                </div>

              </div>

            </section>


            {/* ==================================================
                FEATURES
                ================================================== */}

            <section className="features-banner reveal">

              <div className="feature-item">
                <FaPaintBrush className="feature-icon" />

                <span className="feature-text">
                  HAND-PAINTED
                  <br />
                  CALLIGRAPHY ART
                </span>
              </div>


              <div className="feature-item">
                <FaHeart className="feature-icon" />

                <span className="feature-text">
                  INSPIRED BY QUR'AN
                  <br />
                  &amp; ISLAMIC VALUES
                </span>
              </div>


              <div className="feature-item">
                <FaStar className="feature-icon" />

                <span className="feature-text">
                  PREMIUM QUALITY
                  <br />
                  MATERIALS
                </span>
              </div>


              <div className="feature-item">
                <FaTruck className="feature-icon" />

                <span className="feature-text">
                  SAFE PACKAGING
                  <br />
                  &amp; NATIONWIDE DELIVERY
                </span>
              </div>


              <div className="feature-item">
                <FaGlobe className="feature-icon" />

                <span className="feature-text">
                  AVAILABLE ONLINE
                  <br />
                  ACROSS PAKISTAN
                </span>
              </div>

            </section>


            {/* ==================================================
                ART TITLE
                ================================================== */}

            <h2 className="section-title reveal">
              ART THAT TOUCHES HEARTS
            </h2>


            {/* ==================================================
                ART + STORY
                ================================================== */}

            <section className="art-story">

              <div className="art-gallery">

                <div className="art-card reveal">
                  <img
                    src={artwork1}
                    alt="Noor Un Alaa Noor Artwork 1"
                  />
                </div>

                <div className="art-card reveal delay-1">
                  <img
                    src={artwork2}
                    alt="Noor Un Alaa Noor Artwork 2"
                  />
                </div>

                <div className="art-card reveal delay-2">
                  <img
                    src={artwork3}
                    alt="Noor Un Alaa Noor Artwork 3"
                  />
                </div>

              </div>


              <div className="story-card reveal delay-2">

                <div className="story-title">
                  OUR STORY
                </div>

                <p className="story-text">
                  Noor Un Alaa Noor is a women-led family
                  initiative, run solely by the women of our
                  family. Every artwork is thoughtfully
                  hand-painted with love, patience, and sincerity.
                </p>

                <p className="story-text">
                  Our mission is to spread the beauty of Islamic
                  calligraphy through art that brings peace,
                  positivity and barakah into your homes and hearts.
                </p>

                <div className="women-badge">

                  <FaUsers />

                  <span>
                    RUN SOLELY BY THE WOMEN OF OUR FAMILY
                  </span>

                </div>

              </div>

            </section>


            {/* ==================================================
                INFORMATION GRID
                ================================================== */}

            <section className="information-grid">

              {/* =================================================
                  COLUMN 1
                  ================================================= */}

              <div className="info-column">

                <div className="info-card reveal">

                  <div className="info-title">
                    OUR ARTWORK RANGE
                  </div>

                  <ul className="check-list">

                    <li>
                      <FaCheck />
                      Qur'anic Ayat Calligraphy
                    </li>

                    <li>
                      <FaCheck />
                      Islamic Quotes &amp; Duas
                    </li>

                    <li>
                      <FaCheck />
                      Custom Orders
                    </li>

                    <li>
                      <FaCheck />
                      Canvas Paintings
                    </li>

                    <li>
                      <FaCheck />
                      Gift &amp; Home Décor Pieces
                    </li>

                  </ul>

                </div>


                <div className="info-card reveal delay-1">

                  <div className="info-title">
                    WHY CHOOSE OUR ART?
                  </div>

                  <ul className="check-list">

                    <li>
                      <FaCheck />
                      100% Hand-Painted Original Art
                    </li>

                    <li>
                      <FaCheck />
                      Meaningful &amp; Authentic Islamic Art
                    </li>

                    <li>
                      <FaCheck />
                      Perfect for Home, Office &amp; Gifting
                    </li>

                    <li>
                      <FaCheck />
                      Custom Designs Available
                    </li>

                    <li>
                      <FaCheck />
                      Trusted by Customers Nationwide
                    </li>

                    <li>
                      <FaCheck />
                      Made with Passion &amp; Purpose
                    </li>

                  </ul>

                </div>

              </div>


              {/* =================================================
                  COLUMN 2
                  ================================================= */}

              <div className="info-column">

                <div className="process-card reveal">

                  <div className="info-title">
                    OUR CREATIVE PROCESS
                  </div>

                  <div className="process-row">

                    <div className="process-step">

                      <div className="process-circle">
                        <FaLightbulb />
                      </div>

                      <span className="process-label">
                        CONCEPT &
                        <br />
                        INSPIRATION
                      </span>

                    </div>


                    <span className="process-arrow">
                      →
                    </span>


                    <div className="process-step">

                      <div className="process-circle">
                        <FaPalette />
                      </div>

                      <span className="process-label">
                        DESIGN &
                        <br />
                        SKETCH
                      </span>

                    </div>


                    <span className="process-arrow">
                      →
                    </span>


                    <div className="process-step">

                      <div className="process-circle">
                        <FaPaintBrush />
                      </div>

                      <span className="process-label">
                        HAND-PAINTED
                        <br />
                        WITH CARE
                      </span>

                    </div>


                    <span className="process-arrow">
                      →
                    </span>


                    <div className="process-step">

                      <div className="process-circle">
                        <FaClipboardCheck />
                      </div>

                      <span className="process-label">
                        QUALITY CHECK
                        <br />
                        &amp; PACKAGING
                      </span>

                    </div>

                  </div>

                  <p className="process-description">
                    Every piece is unique. Every stroke is
                    intentional. Every artwork is made to inspire.
                  </p>

                </div>


                {/* =================================================
                    ROOM IMAGE
                    ================================================= */}

                <div className="room-card reveal delay-1">

                  <img
                    src={roomImage}
                    alt="Noor Un Alaa Noor Home Artwork"
                  />

                </div>


                {/* =================================================
                    CUSTOMER ROW
                    ================================================= */}

                <div className="customer-row">

                  <div className="customer-card reveal">

                    <div className="info-title">
                      LOVED BY OUR CUSTOMERS
                    </div>

                    <div className="customer-images">

                      <img
                        src={customerImage1}
                        alt="Customer Artwork"
                        className="customer-image"
                      />

                      <img
                        src={customerImage2}
                        alt="Customer Artwork"
                        className="customer-image"
                      />

                    </div>

                  </div>


                  <div className="instagram-card reveal delay-1">

                    <div className="instagram-profile">

                      <div className="instagram-avatar">
                        N
                      </div>

                      <div>

                        <div className="instagram-name">
                          noorunalaa_noor
                        </div>

                        <div className="instagram-stats">
                          Follow our creative journey
                        </div>

                      </div>

                    </div>


                    <div className="instagram-content">

                      <h3>
                        FOLLOW OUR ART JOURNEY
                        <br />
                        ON INSTAGRAM
                      </h3>

                      <div className="instagram-handle">

                        <FaInstagram />

                        @noorunalaa_noor

                      </div>

                      <span className="instagram-small">
                        Custom Orders &amp; Inquiries Welcome! ♡
                      </span>

                    </div>

                  </div>

                </div>

              </div>


              {/* =================================================
                  COLUMN 3
                  ================================================= */}

              <div className="info-column">

                <div className="info-card reveal">

                  <div className="info-title">
                    WHY CHOOSE OUR ART?
                  </div>

                  <ul className="check-list">

                    <li>
                      <FaHeart />
                      Meaningful &amp; Authentic Islamic Art
                    </li>

                    <li>
                      <FaHeart />
                      Perfect for Home, Office &amp; Gifting
                    </li>

                    <li>
                      <FaHeart />
                      Custom Designs Available
                    </li>

                    <li>
                      <FaHeart />
                      Trusted by Customers Nationwide
                    </li>

                    <li>
                      <FaHeart />
                      Made with Passion &amp; Purpose
                    </li>

                  </ul>

                </div>

              </div>

            </section>


            {/* ==================================================
                BOTTOM QUOTE
                ================================================== */}

            <section className="bottom-quote reveal">

              <span className="bottom-quote-symbol">
                “
              </span>

              <div className="bottom-quote-content">

                <span className="bottom-quote-text">
                  Art is not just what we see,
                  but what our hearts feel.
                </span>

                <span className="bottom-quote-sub">
                  Bringing light, beauty and meaning into every space.
                </span>

              </div>

              <span className="bottom-quote-symbol">
                ”
              </span>

            </section>


            {/* ==================================================
                FOOTER
                ================================================== */}

            <footer className="noor-footer">

              <div className="footer-page-number">
                17
              </div>


              <div className="footer-company">

                <span className="footer-company-name">
                  ASHRAF GROUP OF INDUSTRIES
                </span>

                <span className="footer-company-tagline">
                  Building Legacy. Powering the Future.
                </span>

              </div>


              <div className="footer-pillars">

                <div className="footer-pillar">

                  <FaSmile />

                  <span>
                    CREATING
                    <br />
                    WITH PURPOSE
                  </span>

                </div>


                <div className="footer-pillar">

                  <FaHeart />

                  <span>
                    DRIVEN
                    <br />
                    BY FAITH
                  </span>

                </div>


                <div className="footer-pillar">

                  <FaUsers />

                  <span>
                    WOMEN
                    <br />
                    EMPOWERMENT
                  </span>

                </div>


                <div className="footer-pillar">

                  <FaHandsHelping />

                  <span>
                    SUPPORTING
                    <br />
                    CREATIVITY
                  </span>

                </div>


                <div className="footer-pillar">

                  <FaShieldAlt />

                  <span>
                    SPREADING
                    <br />
                    POSITIVITY
                  </span>

                </div>

              </div>

            </footer>

          </div>

        </main>

      </div>
    </>
  );
}